'use client';

import styled, { keyframes } from 'styled-components';

export const StyledCrunchingNumbers = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${props => props.theme.colors.get(props.$backgroundColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${props => props.theme.spacing(8)};

  @media ${props => props.theme.laptop} {
    padding-top: ${props => props.theme.spacing(16)};
  }
`;

export const LogoHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;
  gap: ${props => props.theme.spacing(10)};
  padding-bottom: ${props => props.theme.spacing(6)};
  @media ${props => props.theme.laptop} {
    padding-bottom: ${props => props.theme.spacing(8)};
  }
`;

const fillBar = keyframes`
  from { width: 5%; }
  to { width: 100%; }
`;

export const LoadingBarContainer = styled.div`
  height: 8px;
  width: 295px;
  background-color: ${props =>
    props.$loadingBarBgColor
      ? props.theme.colors.get(props.$loadingBarBgColor)
      : '#F7E4FE'};
  overflow: hidden;
  border-radius: 30px;
  margin-bottom: ${props => props.theme.spacing(6)};
  @media ${props => props.theme.laptop} {
    margin-bottom: ${props => props.theme.spacing(8)};
  }
`;

export const LoadingBarProgress = styled.div`
  height: 100%;
  background-color: ${props =>
    props.theme.colors.get(props.$loadingBarFillColor)};
  width: 0%;
  animation: ${fillBar} calc(${({ $duration }) => $duration}s - 1s) linear
    forwards;
`;

const fadeUp = keyframes`
  0%   { opacity: 0; transform: translateY(20px); }
  10%  { opacity: 1; transform: translateY(0); }
  90%  { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
`;

const fadeUpLast = keyframes`
  0%   { opacity: 0; transform: translateY(20px); }
  10%  { opacity: 1; transform: translateY(0); }
  90%  { opacity: 1; transform: translateY(0); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const Slideshow = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
`;

export const Slide = styled.div`
  margin: auto;
  text-align: center;
  position: absolute;
  inset: 0;
  opacity: 0;
  will-change: opacity, transform;

  animation-name: ${({ $isLast }) => ($isLast ? fadeUpLast : fadeUp)};
  animation-duration: ${({ $slideDuration }) => $slideDuration}s;
  animation-delay: ${({ $delay }) => $delay}s;
  animation-fill-mode: forwards;
  animation-timing-function: ease;
  width: 100vw;

  img {
    width: 35vw;
    height: 38vh;
    min-width: 297px;
    min-height: 230px;
    max-width: 512px;
    max-height: 396px;
    border-radius: 24px;
  }
`;

export const CaptionText = styled.h5`
  ${({ theme }) => theme.typography.heading5};
  ${({ theme }) => theme.fontFamily.base};
  color: ${props => props.theme.colors.get(props.$fontColor)};

  padding: ${props => props.theme.spacing(7, 4, 0)};
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(8, 4, 0)};
  }
`;
